import { RecordReadError } from "@/components/helpers/RecordReadError";
import { RecordLoader } from "@/components/record/RecordLoader";

import PageLoader from "@/components/ui/PageLoader";
import { useGetRecordQueryCtx } from "@/hooks/useGetRecordQueryCtx";
import { lazy, Suspense } from "react";
const ClientPage = lazy(() => import("@/pages/entities/clientPage"));

export const VersionSelector = () => {

  const {
    data: { scope } = {},
    isLoading,
    isError,
    recordId,
  } = useGetRecordQueryCtx();

  if (isError) {
    return <RecordReadError />;
  }

  if (!recordId || !scope) {
    return <PageLoader />;
  }

  if (isLoading) {
    return <RecordLoader />;
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <ClientPage />
    </Suspense>
  );
};

export default VersionSelector;
